/**
 * PixiJS application setup — render-exempt file (test-spec §7.2): wiring
 * only, no game rules.
 */

import { Application, Container } from "pixi.js";

export interface CanvasHandles {
  app: Application;
  world: Container;
}

export async function createRenderer(mount: HTMLElement): Promise<CanvasHandles> {
  const app = new Application();
  await app.init({
    background: "#1a1d24",
    resizeTo: mount,
    // WebGL preferred in production per PixiJS guidance (phase1-plan §2).
    preference: "webgl",
  });
  mount.appendChild(app.canvas);

  const world = new Container();
  app.stage.addChild(world);
  return { app, world };
}
